var exports = {
  "k": "x9245d464--8baeb4--container",
  "v": "x9245d464--8baeb4--clickable",
};

module.exports = exports;
